var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatingMaintenance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);}.cls-2{fill:#00515a;}.cls-3{fill:#006571;}.cls-4{fill:#007c8a;}.cls-5{fill:#f07662;}.cls-6{fill:#eaf3fa;}.cls-7{fill:#e7f3f8;}.cls-8,.cls-9{fill:#fff;}.cls-10{fill:#f39889;}.cls-11{fill:#e5e5e5;}.cls-12{fill:#e4e7ef;}.cls-13{fill:#b5d0ee;}.cls-14{fill:#90a6be;}.cls-15{fill:#c2dff0;}.cls-16{fill:#914247;}.cls-17{fill:#adb5c1;}.cls-18{fill:#ccc;}.cls-19{fill:#cfe1ec;}.cls-20{fill:#e10770;}.cls-21{fill:#4a535a;}.cls-22{fill:#4a9da7;}.cls-23{fill:#798b86;}.cls-24{fill:#4d1626;}.cls-9{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 87.46,
    y: 67.8,
    width: 6.22,
    height: 14.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-9",
    points: "87.46 67.8 93.68 67.8 93.68 82 87.46 82 87.46 67.8"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Axa.be-Fixico-_-Homecare"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AXA-Homecare--Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-101"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "cls-11",
    points: "86 75.93 86 34.57 96.46 29.24 96.46 70.67 86 75.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    className: "cls-18",
    points: "27.8 5.33 86 34.57 86 75.93 27.8 46.83 27.8 5.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    className: "cls-12",
    points: "96.46 29.24 38.2 0 27.8 5.33 86 34.57 96.46 29.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-17",
    d: "m71.38,32.15l1.42.76v32.98l-1.42-.62v-33.12Zm3.46,1.7l1.42.76v32.98l-1.42-.62v-33.12Zm3.5,1.77l1.42.76v32.98l-1.42-.62v-33.12Zm3.46,1.7l1.42.76v32.98l-1.42-.62v-33.12Zm-24.21-12.02l1.42.76v32.98l-1.42-.62V25.29Zm3.46,1.7l1.42.76v32.98l-1.42-.62V26.98Zm3.5,1.77l1.42.76v32.98l-1.42-.62V28.75Zm3.46,1.7l1.42.76v32.98l-1.42-.62V30.45Zm-24.21-12.05l1.42.76v32.98l-1.42-.62V18.39Zm-3.22-1.7l1.42.76v32.98l-1.42-.62V16.7Zm-3.4-1.7l1.42.76v32.98l-1.42-.62V15Zm-3.43-1.66l1.42.76v32.98l-1.42-.62V13.34Zm-3.33-1.66l1.42.76v32.98l-1.42-.62V11.67Zm16.84,8.42l1.42.76v32.98l-1.42-.62V20.09Zm3.5,1.77l1.42.76v32.98l-1.42-.62V21.86Zm3.46,1.7l1.42.76v32.98l-1.42-.62V23.56Zm31.8,12.89l-.09-.04L27.8,7.46v-.45l58.23,28.99,10.43-5.09v.45l-10.43,5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    className: "cls-21",
    d: "m92.65,37.29c-.69-.25-1.56.44-1.95,1.54-.39,1.09-.15,2.18.54,2.43l1.41.6,1.9-3.58-1.9-.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    className: "cls-10",
    d: "m98.52,38.72l-3.06-1.34c-1.17-.42-2.62.65-3.24,2.38-.62,1.73-.17,3.47,1,3.89l3.06,1.34c1.17.42,2.62-.65,3.24-2.38.62-1.73.17-3.47-1-3.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    className: "cls-5",
    d: "m99.52,42.61c-.62,1.73-2.06,2.8-3.24,2.38-1.17-.42-1.62-2.16-1-3.89.62-1.73,2.07-2.8,3.24-2.38,1.17.42,1.62,2.16,1,3.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    className: "cls-21",
    d: "m92.53,28.2l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.7-1.21l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.42l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.63-1.21l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.34-1.25l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.74-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.6-1.39l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.74-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.39l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.74-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.34-1.21l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm-2.56-1.28l1.57.8-8.14,4.19-1.66-.8,8.23-4.19Zm49.1,67.98v2.6s.16,1.25,1.04.83l5.77-2.86s.67-.36.73-2.03v-2.18s-.05-1.2-1.2-.62l-5.35,2.6s-.99.57-.99,1.66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    className: "cls-5",
    d: "m88.1,67.8l3.6,1.94s2.02.95,1.97,2.94v8.13s.16,1.09-1.09,1.2c-1.25.1-1.04-1.09-1.04-1.09v-7.74s.02-.94-.8-1.35c-.81-.42-3.26-1.78-3.26-1.78,0,0-.24-1.7.61-2.23"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    className: "cls-14",
    d: "m91.7,65.93l3.79,2.03s2.03.95,1.97,2.94v8.13s.16,1.09-1.09,1.19c-1.25.1-1.04-1.09-1.04-1.09v-7.74s.02-.94-.8-1.35c-.81-.41-5.5-2.82-5.5-2.82,0,0,1.81-.76,2.66-1.29"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Bricoleur"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "25.94 86.53 39.41 94.29 39.68 99.6 31.25 100 21.3 94.56 21.3 89.38 25.94 86.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "39.41 94.29 31.18 94.96 31.25 100 39.68 99.6 39.41 94.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "21.23 89.38 21.23 94.56 31.25 100 31.18 94.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m49.05,78.55s2.08-.4,3.05.84.84,2.7.84,2.7l-17.31,10.03-4.74-2.73,18.16-10.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m52.23,79.55s.99,1.14.9,2.53l-17.35,10.11-2.37-1.37,18.83-11.28Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 26.12,
    cy: 95.01,
    rx: 1.33,
    ry: 2.52,
    transform: "translate(-66.05 60.16) rotate(-53.92)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 26,
    cy: 95.16,
    rx: 1.33,
    ry: 2.52,
    transform: "translate(-66.22 60.14) rotate(-53.92)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "29.39 85.87 44.47 77.23 44.38 62.05 41.4 58.26 14.7 42.8 3.17 50.14 0 53.46 0 56.58 .29 57.2 0 57.73 0 68.83 29.39 85.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "29.25 70.55 0 53.46 0 56.58 .29 57.2 0 57.73 0 68.83 29.39 85.87 29.25 70.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "44.38 61.81 29.25 70.55 29.39 85.87 44.47 77.23 44.38 62.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "44.47 65.43 29.28 74.04 .19 57.06 .19 57.53 29.29 74.6 44.47 66.04 44.47 65.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "44.47 62.1 29.25 70.55 29.39 65.03 41.4 58.26 44.47 62.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "29.39 65.03 3.17 50.14 0 53.46 29.25 70.55 29.39 65.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "41.4 58.26 14.7 42.8 3.17 50.14 29.39 65.03 41.4 58.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "26.25 57.65 15.14 51.02 17.26 50.93 28.69 57.17 26.25 57.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.69 57.17 27.34 58.13 26.25 57.65 26.25 53.2 17.26 47.92 17.26 50.93 16.23 51.6 15.14 51.02 15.14 45.29 16.42 44.4 28.69 51.41 28.69 57.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "27.34 58.13 27.34 52.08 15.14 45.29 15.14 51.02 16.23 51.6 16.3 47.45 26.25 53.2 26.25 57.65 27.34 58.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "21.39 67.52 23.88 68.92 23.88 75.61 22.96 75.61 20.91 74.11 20.91 68.27 21.39 67.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "22.9 69.45 22.96 75.61 20.91 74.11 20.91 68.27 22.9 69.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "4.77 57.53 7.27 58.93 7.27 65.62 6.34 65.62 4.29 64.12 4.29 58.28 4.77 57.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "6.28 59.46 6.34 65.62 4.29 64.12 4.29 58.28 6.28 59.46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatingMaintenance);
export default __webpack_public_path__ + "static/media/heating-maintenance.f747c8896a0e7aca365d36a672a4546c.svg";
export { ForwardRef as ReactComponent };